import { OtaFile } from "../types";

export function getOtaFileReleaseNotes(otaFile: OtaFile): NonNullable<OtaFile["changes"]> {
    return otaFile.changes?.filter((entry) => entry.version === otaFile.version) ?? [];
}

export function hasOtaFileReleaseNotes(releaseNotes: NonNullable<OtaFile["changes"]>): boolean {
    return releaseNotes.some((entry) => entry.changes.some((change) => change.trim() !== ""));
}
